import ExclusiveMembersContainer from "./ExclusiveMembersContainer";

function ExclusiveMembers() {
  return <ExclusiveMembersContainer />;
}

export default ExclusiveMembers;
